import { render, staticRenderFns } from "./MainNavigationLinks.vue?vue&type=template&id=46c13066&scoped=true&"
import script from "./MainNavigationLinks.vue?vue&type=script&lang=js&"
export * from "./MainNavigationLinks.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationLinks.vue?vue&type=style&index=0&id=46c13066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c13066",
  null
  
)

export default component.exports